$('.custom-file-input').on('change', function(){
    let fileName = $(this)[0].files[0].name;
    let nextSibling = $(this).next();
    nextSibling.html('/fakepath/' + fileName);
});
